module.exports = __webpack_public_path__ + "img/dropdown-triangle-white.72aab76d.svg";